module.exports = __webpack_public_path__ + "static/media/health6.2a5cdaf7.svg";